import { useParams, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { useEffect } from 'react';
import { TransactionWarnings } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import {
  setBlacklistData,
  setBlacklistDataVisible,
  setBlacklistDataItem,
  setBlacklistItemVisible,
  changePanelState,
} from '../../../store/slices/problem-transactions/internal-transaction';
import useProblemInternalTransaction from '../hooks/use-internal';

const InternalTransactionWarning = (): React.JSX.Element => {
  const {
    warnings,
    transaction,
    senderCompanyOfficials,
    recipientCompanyOfficials,
    chats,
  } = useAppSelector((state) => state.customersProblemTransactions.internal);
  const { customersTransactionTypes, currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  const dispatch = useAppDispatch();

  const { transactionId } = useParams();

  const {
    getSenderAccounts,
    getRecipientAccounts,
    chatCreateInProgress,
    createChatWithMessage,
    getInternalTransactionWarningByIdAction,
    isWarningByIdLoading,
    isWarningByIdFetching,
  } = useProblemInternalTransaction({
    transactionId,
    transaction,
    currenciesList,
    currentEmployee,
    sendMessage,
  });

  useEffect(() => {
    if (
      transaction &&
      transaction.senderAccount &&
      transaction.senderAccount?.organization?.type === 'CORPORATE' &&
      !senderCompanyOfficials
    ) {
      getSenderAccounts(transaction.senderAccount.organizationId);
    }
  }, [transaction, senderCompanyOfficials]);

  useEffect(() => {
    if (
      transaction &&
      transaction.recipientAccount &&
      transaction.recipientAccount?.organization?.type === 'CORPORATE' &&
      !recipientCompanyOfficials
    ) {
      getRecipientAccounts(transaction.recipientAccount.organizationId);
    }
  }, [transaction]);

  return (
    <TransactionWarnings
      warnings={warnings}
      employee={undefined}
      transactionsTypes={customersTransactionTypes}
      setBlacklistDataVisible={(visible) => {
        dispatch(setBlacklistDataVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistData={(data) => dispatch(setBlacklistData(data))}
      setBlacklistItemVisible={(visible) => {
        dispatch(setBlacklistItemVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistDataItem={(data) => dispatch(setBlacklistDataItem(data))}
      transactionUrlType="internal"
      transactionId={transactionId}
      recipients={recipientCompanyOfficials}
      senders={senderCompanyOfficials}
      recipientAccount={transaction?.recipientAccount}
      senderAccount={transaction?.senderAccount}
      chats={chats}
      createChatWithMessage={createChatWithMessage}
      chatCreateInProgress={chatCreateInProgress}
      getWarningById={getInternalTransactionWarningByIdAction}
      isWarningByIdLoading={isWarningByIdLoading}
      isWarningByIdFetching={isWarningByIdFetching}
      isInternal
      withTransactionUrl
    />
  );
};

export default InternalTransactionWarning;
